import React, { useCallback, useState, useEffect } from 'react'
import classNames from 'classnames'

import { Image } from '../../components/Image/Image'
import { Audio } from '../../components/Audio/Audio'
import { GameWrapper } from '../../components/GameWrapper/GameWrapper'

import styles from './GameAnimals.module.scss'
import bgImg from './bg.png'
import img00 from './animal-00.png'
import img01 from './animal-01.png'
import img02 from './animal-02.png'
import img03 from './animal-03.png'
import img04 from './animal-04.png'
import img05 from './animal-05.png'
import img06 from './animal-06.png'
import img07 from './animal-07.png'
import img08 from './animal-08.png'
import digAllimg from './dig-all.png'
import dig0 from './dig-0.png'
import dig1 from './dig-1.png'
import dig2 from './dig-2.png'
import dig3 from './dig-3.png'
import dig4 from './dig-4.png'
import dig5 from './dig-5.png'
import dig6 from './dig-6.png'
import dig7 from './dig-7.png'
import dig8 from './dig-8.png'
import dig9 from './dig-9.png'
import animal00 from './animal-00.mp3'
import animal01 from './animal-01.mp3'
import animal02 from './animal-02.mp3'
import animal03 from './animal-03.mp3'
import animal04 from './animal-04.mp3'
import animal06 from './animal-06.mp3'
import animal07 from './animal-07.mp3'
import animal08 from './animal-08.mp3'


const ANIMALS = [
    img00,
    img01,
    img02,
    img03,
    img04,
    img05,
    img06,
    img07,
    img08,
]

const ANIMAL_AUDIOS = [
    animal00,
    animal01,
    animal02,
    animal03,
    animal04,
    null,
    animal06,
    animal07,
    animal08,
]

const DIGITS = [
    dig0,
    dig1,
    dig2,
    dig3,
    dig4,
    dig5,
    dig6,
    dig7,
    dig8,
    dig9,
]

function GameAnimals() {
    const [win, setWin] = useState(false)
    const [doneParts, setDoneParts] = useState([])

    useEffect(() => {
        if (doneParts.length === 9) {
            setWin(true)
        }
    }, [doneParts, setWin])

    const clickHandler = useCallback((clickedIndex) => {
        if (win) {
            return
        }

        if (!doneParts.includes(clickedIndex)) {
            setDoneParts([...doneParts, clickedIndex])
        }
    }, [win, doneParts, setDoneParts])

    return (
        <GameWrapper win={win} people="1">
            <Image src={bgImg} className={styles.bg} />

            {
                ANIMALS.map((img, index) => (
                    doneParts.includes(index)
                        ? (
                            <div key={img}>
                                <Image
                                    src={img}
                                    onClick={() => { clickHandler(index) }}
                                    className={classNames(`animal-0${index}`, styles.done)}
                                />
                                {
                                    ANIMAL_AUDIOS[index]
                                        ? <Audio src={ANIMAL_AUDIOS[index]} autoplay />
                                        : null
                                }
                            </div>
                        )
                        : <div key={img} />
                ))
            }

            {
                ANIMALS.map((img, index) => (
                    doneParts.includes(index)
                        ? <div key={img} />
                        : (
                            <Image
                                key={img}
                                src={img}
                                onClick={() => { clickHandler(index) }}
                                className={`animal-0${index}`}
                            />
                        )
                ))
            }

            <Image src={digAllimg} className={styles.digAll} />
            <Image src={DIGITS[doneParts.length]} className={`dig-${doneParts.length}`} />
        </GameWrapper>
    )
}

GameAnimals.propTypes = {}

export { GameAnimals }
